import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { register, clearError } from '../store/authSlice';
import { useNavigate, Link } from 'react-router-dom';

const STORAGE_KEY = 'finema_recent_emails';

function saveRecentEmail(email) {
  try {
    const list = (JSON.parse(localStorage.getItem(STORAGE_KEY)) || []).filter(e => e !== email);
    list.unshift(email);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 2)));
  } catch {}
}

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [pwFocused, setPwFocused] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, registeredEmail } = useSelector((state) => state.auth);

  const pwHasLength = password.length >= 8;
  const pwHasNumber = /[0-9]/.test(password);
  const pwHasUpper = /[A-Z]/.test(password);

  useEffect(() => {
    if (registeredEmail) navigate('/verify-email-sent', { state: { email: registeredEmail } });
  }, [registeredEmail, navigate]);

  useEffect(() => {
    return () => dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    saveRecentEmail(email);
    dispatch(register({ email, password, displayName }));
  };

  return (
    <div className="auth-page">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Create Account</h2>
        {error && <div className="error-msg">{error}</div>}
        <input type="text" name="displayName" placeholder="Name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} autoComplete="name" required />
        <input type="email" name="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
        <input type="password" name="password" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          onFocus={() => setPwFocused(true)}
          onBlur={() => setPwFocused(false)}
          autoComplete="new-password" required minLength={8} />
        {(pwFocused || password.length > 0) && (
          <div className="password-hints">
            <span className={pwHasLength ? 'pw-hint valid' : 'pw-hint'}>Min 8 characters</span>
            <span className={pwHasNumber ? 'pw-hint valid' : 'pw-hint'}>1 number</span>
            <span className={pwHasUpper ? 'pw-hint valid' : 'pw-hint'}>1 uppercase</span>
          </div>
        )}
        <button type="submit" disabled={loading} className="btn btn-primary">
          {loading ? 'Creating account...' : 'Sign Up'}
        </button>
        <p className="auth-link">Already have an account? <Link to="/login">Log in</Link></p>
      </form>
    </div>
  );
}
